'use client';

import { useDrawerStore } from '@/stores';

import { IdentityVerificationDrawer } from '../IdentityVerificationDrawer';

const identityVerificationDrawerConfig = {
  title: 'Verificação de identidade',
  Component: IdentityVerificationDrawer,
  drawerHeaderOptions: { className: 'text-center' },
  drawerType: 'identity-verification',
} as const;

type UseIdentityVerificationDrawerReturn = {
  openIdentityVerificationDrawer: () => void;
};

export const useIdentityVerificationDrawer = (): UseIdentityVerificationDrawerReturn => {
  const openDrawer = useDrawerStore((state) => state.openDrawer);
  const replaceDrawer = useDrawerStore((state) => state.replaceDrawer);
  const drawers = useDrawerStore((state) => state.drawers);

  const openIdentityVerificationDrawer = () => {
    const hasOpenDrawer = drawers.length > 0;

    if (hasOpenDrawer) {
      replaceDrawer(identityVerificationDrawerConfig);
    } else {
      openDrawer(identityVerificationDrawerConfig);
    }
  };

  return { openIdentityVerificationDrawer };
};
